// Alaine's Compass — starter testing directory: university food science programs,
// process authorities, and commercial food testing labs.
// Compiled July 2026 from public sources: UMass Extension lab list, SafeFood.net lab finder,
// Cornell Food Venture Center, NC State Extension, university food science program sites,
// and lab websites. Services and fees change — always confirm directly with the provider.

export const TESTING_DIRECTORY = [
  {
    "id": "tl-001",
    "name": "Advanced Food Labs Inc.",
    "city": "Chelsea",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "microbiology",
      "allergen testing",
      "product development",
      "shelf life"
    ],
    "website": "https://www.advancedfoodlabs.com/",
    "notes": "A commercial lab providing food safety and development services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-002",
    "name": "BAL Laboratory",
    "city": "Cranston",
    "state": "RI",
    "type": "commercial-lab",
    "services": [
      "microbiology"
    ],
    "website": "http://www.ballaboratory.com/",
    "notes": "Offers microbiological testing services for food.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-003",
    "name": "Biomarine Research Corporation",
    "city": "Gloucester",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "microbiology"
    ],
    "website": "http://www.biomarinelab.com/",
    "notes": "Provides microbiology testing services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-004",
    "name": "EMSL Food Testing",
    "city": "Wallingford",
    "state": "CT",
    "type": "commercial-lab",
    "services": [
      "allergen testing",
      "microbiology",
      "nutrition analysis",
      "shelf life"
    ],
    "website": "http://www.emsl.com/Services.aspx?action=list&ServiceCategoryID=105",
    "notes": "Provides comprehensive food safety and nutrition analysis.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-005",
    "name": "Eurofins Microbiology Inc.",
    "city": "Hanover",
    "state": "MD",
    "type": "commercial-lab",
    "services": [
      "microbiology",
      "product development",
      "label review"
    ],
    "website": "https://www.eurofinsus.com/",
    "notes": "Offers microbiology and product development support.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-006",
    "name": "Foods Research Laboratories",
    "city": "Boston",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "label review",
      "nutrition analysis",
      "shelf life",
      "allergen testing"
    ],
    "website": "https://rlfoodtestinglaboratory.com/",
    "notes": "Provides label review and food testing services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-008",
    "name": "Krueger Food Laboratories",
    "city": "Chelmsford",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "microbiology",
      "nutrition analysis"
    ],
    "website": "https://www.kfl.com",
    "notes": "Provides microbiology and nutrition analysis.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-010",
    "name": "Microbac",
    "city": "Lee",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "nutrition analysis",
      "shelf life",
      "microbiology",
      "scheduled process"
    ],
    "website": "http://www.microbac.com",
    "notes": "Provides analytical testing and process scheduling services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-011",
    "name": "Northeast Laboratory Services",
    "city": "Waterville",
    "state": "ME",
    "type": "commercial-lab",
    "services": [
      "microbiology",
      "nutrition analysis",
      "shelf life"
    ],
    "website": "http://nelabservices.com",
    "notes": "Offers microbiology and nutrition testing services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-012",
    "name": "Northeast Laboratory, Inc.",
    "city": "Berlin",
    "state": "CT",
    "type": "commercial-lab",
    "services": [
      "nutrition analysis",
      "microbiology",
      "shelf life"
    ],
    "website": "http://www.nelabsct.com",
    "notes": "Provides analytical services for food safety.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-013",
    "name": "Silliker",
    "city": "Crete",
    "state": "IL",
    "type": "commercial-lab",
    "services": [
      "label review",
      "sensory",
      "shelf life"
    ],
    "website": "https://na.mxns.com/",
    "notes": "Provides sensory and shelf life testing services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-015",
    "name": "Thielsch Engineering",
    "city": "Cranston",
    "state": "RI",
    "type": "commercial-lab",
    "services": [
      "microbiology"
    ],
    "website": "http://www.thielsch.com/",
    "notes": "Offers microbiological analysis.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-016",
    "name": "Trelfa Labs",
    "city": "Salisbury",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "label review"
    ],
    "website": "http://trelfalabs.com",
    "notes": "Provides label review services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-018",
    "name": "Vallid Labs",
    "city": "Agawam",
    "state": "MA",
    "type": "commercial-lab",
    "services": [
      "microbiology",
      "nutrition analysis",
      "shelf life"
    ],
    "website": "http://validlabs.com/",
    "notes": "Offers microbiology and nutrition analysis services.",
    "source": "UMass Extension"
  },
  {
    "id": "tl-019",
    "name": "Cornell Food Venture Center",
    "city": "Geneva",
    "state": "NY",
    "type": "university",
    "services": [
      "process authority",
      "product development",
      "scheduled process",
      "ph/acidity",
      "water activity",
      "shelf life"
    ],
    "website": "https://cals.cornell.edu/cornell-agritech/partners-institutes/cornell-food-venture-center/cfvc-services-fees",
    "notes": "The CFVC provides comprehensive assistance to food entrepreneurs regarding product safety, process development, and regulatory compliance.",
    "source": "Cornell CALS"
  },
  {
    "id": "tl-020",
    "name": "Microbial & Shelf Life Studies Extension Lab",
    "city": "Geneva",
    "state": "NY",
    "type": "university",
    "services": [
      "microbiology",
      "shelf life"
    ],
    "website": "https://blogs.cornell.edu/worobolab/worobo-service-lab/",
    "notes": "This extension lab provides specialized testing for shelf life and microbiology.",
    "source": "Cornell CALS"
  },
  {
    "id": "tl-021",
    "name": "Cornell Craft Beverage Analytical Lab",
    "city": "Geneva",
    "state": "NY",
    "type": "university",
    "services": [
      "nutrition analysis"
    ],
    "website": "https://cals.cornell.edu/cornell-agritech/our-expertise/craft-beverage-production/craft-beverage-analytical-lab/sample-submission",
    "notes": "They provide analysis services including alcohol content for craft beverage regulatory compliance.",
    "source": "Cornell CALS"
  },
  {
    "id": "tl-022",
    "name": "Plant Food Processing",
    "city": "Raleigh",
    "state": "NC",
    "type": "university",
    "services": [
      "shelf life",
      "product development"
    ],
    "website": "https://cals.ncsu.edu/food-bioprocessing-and-nutrition-sciences/extension-and-outreach/extension-programs-and-product-testing/plant-food-processing/",
    "notes": "Provides support for shelf life and product development for plant foods.",
    "source": "NCSU Extension"
  },
  {
    "id": "tl-023",
    "name": "Seafood Laboratory",
    "city": "Morehead City",
    "state": "NC",
    "type": "university",
    "services": [
      "product development"
    ],
    "website": "https://seafoodscience.ces.ncsu.edu/",
    "notes": "Focuses on product development for the seafood industry.",
    "source": "NCSU Extension"
  },
  {
    "id": "tl-024",
    "name": "Entrepreneur Initiative for Food Program (EI4F)",
    "city": "Raleigh",
    "state": "NC",
    "type": "university",
    "services": [
      "process authority",
      "nutrition analysis"
    ],
    "website": "https://foodbusiness.ces.ncsu.edu/",
    "notes": "Assists food entrepreneurs with process authority and nutritional analysis.",
    "source": "NCSU Extension"
  },
  {
    "id": "tl-025",
    "name": "Sensory Service Center",
    "city": "Raleigh",
    "state": "NC",
    "type": "university",
    "services": [
      "sensory"
    ],
    "website": "https://sensory.ncsu.edu/",
    "notes": "Offers sensory analysis services.",
    "source": "NCSU Extension"
  },
  {
    "id": "tl-026",
    "name": "University of Tennessee Process Innovation Laboratory",
    "city": "Knoxville",
    "state": "TN",
    "type": "university",
    "services": [
      "water activity",
      "ph/acidity",
      "nutrition analysis",
      "scheduled process"
    ],
    "website": "https://foodscience.tennessee.edu/services/",
    "notes": "The laboratory provides affordable analytical testing and documentation for small food businesses with a 2-4 week turnaround time.",
    "source": "UT Food Science"
  },
  {
    "id": "tl-027",
    "name": "Food Innovation Center at Rutgers",
    "city": "Piscataway",
    "state": "NJ",
    "type": "university",
    "services": [
      "sensory",
      "product development",
      "nutrition analysis",
      "shelf life"
    ],
    "website": "https://foodinnovation.rutgers.edu/services/#breakthrough-page-title",
    "notes": "Supports food businesses with product development and testing.",
    "source": "Rutgers Food Innovation Center"
  },
  {
    "id": "tl-028",
    "name": "Food Innovation Center (FIC) Agricultural Experiment Station",
    "city": "Portland",
    "state": "OR",
    "type": "university",
    "services": [
      "product development",
      "shelf life",
      "sensory"
    ],
    "website": "https://fic.oregonstate.edu/fic/about-us",
    "notes": "The FIC provides food science expertise, product development, and sensory testing services to help entrepreneurs and companies bring food products to market.",
    "source": "Oregon State FIC"
  },
  {
    "id": "tl-029",
    "name": "Clemson University Food2Market",
    "city": "Clemson",
    "state": "SC",
    "type": "university",
    "services": [
      "ph/acidity",
      "water activity",
      "nutrition analysis",
      "scheduled process"
    ],
    "website": "https://www.clemson.edu/extension/food/programs/food2market/",
    "notes": "This program assists South Carolina food entrepreneurs with regulatory compliance, product testing, and process control letters.",
    "source": "Clemson Extension"
  },
  {
    "id": "tl-030",
    "name": "University of Georgia Extension Food Science and Technology (EFST)",
    "city": "",
    "state": "GA",
    "type": "university",
    "services": [
      "process authority",
      "ph/acidity",
      "water activity",
      "scheduled process",
      "shelf life"
    ],
    "website": "https://foodscience.caes.uga.edu/extension/services/process-authority-services/ph-and-water-activity-testing.html",
    "notes": "Provides process authority and analytical testing services for food businesses.",
    "source": "UGA Extension"
  },
  {
    "id": "tl-031",
    "name": "University of Georgia Food Safety Plan Services",
    "city": "",
    "state": "GA",
    "type": "university",
    "services": [],
    "website": "https://foodscience.caes.uga.edu/extension/services/food-safety-plans.html",
    "notes": "This center provides assistance with the development of formal food safety plans to meet specific regulatory requirements.",
    "source": "UGA Extension"
  },
  {
    "id": "tl-032",
    "name": "Oklahoma State University",
    "city": "Stillwater",
    "state": "OK",
    "type": "university",
    "services": [
      "process authority",
      "ph/acidity",
      "water activity"
    ],
    "website": "https://food.okstate.edu/training-and-services/process-authority",
    "notes": "They provide scientific process evaluations for food safety, charging $350 for in-state and $700 for out-of-state residents.",
    "source": "OSU Food Science"
  },
  {
    "id": "tl-033",
    "name": "The Wilbur A. Gould Food Industries Center (FIC) at The Ohio State University",
    "city": "Columbus",
    "state": "OH",
    "type": "university",
    "services": [
      "product development",
      "sensory",
      "nutrition analysis"
    ],
    "website": "https://foodindustries.osu.edu/research-and-development#main-content",
    "notes": "Offers R&D, product development, and testing services for food industries.",
    "source": "OSU FIC"
  },
  {
    "id": "tl-034",
    "name": "High Pressure Food Processing Lab",
    "city": "Columbus",
    "state": "OH",
    "type": "university",
    "services": [
      "microbiology"
    ],
    "website": "https://fst.osu.edu/",
    "notes": "Specializes in high pressure processing research and microbiology.",
    "source": "OSU FIC"
  },
  {
    "id": "tl-035",
    "name": "Food Safety Lab",
    "city": "Columbus",
    "state": "OH",
    "type": "university",
    "services": [
      "microbiology"
    ],
    "website": "http://fst.osu.edu/foodsafetylab/index.htm",
    "notes": "Focuses on microbiological safety testing.",
    "source": "OSU FIC"
  },
  {
    "id": "tl-036",
    "name": "Food Product Development Lab",
    "city": "Bozeman",
    "state": "MT",
    "type": "university",
    "services": [
      "product development",
      "sensory"
    ],
    "website": "https://www.montana.edu/foodprodevlab/index.html",
    "notes": "Provides product development and sensory testing support.",
    "source": "Montana State"
  },
  {
    "id": "tl-038",
    "name": "Kansas Value Added Foods Lab",
    "city": "Manhattan",
    "state": "KS",
    "type": "university",
    "services": [
      "product development",
      "ph/acidity",
      "microbiology",
      "water activity",
      "nutrition analysis",
      "scheduled process"
    ],
    "website": "https://extension.k-state.edu/kvafl/",
    "notes": "They provide product testing and technical assistance to help small food businesses ensure product safety and compliance.",
    "source": "K-State Research and Extension"
  },
  {
    "id": "tl-039",
    "name": "Meat Science Value Added Services",
    "city": "Manhattan",
    "state": "KS",
    "type": "university",
    "services": [
      "product development"
    ],
    "website": "https://www.asi.k-state.edu/research/meat-science/value-added/",
    "notes": "They provide assistance to small meat processors for developing and evaluating value-added meat products.",
    "source": "K-State Research and Extension"
  },
  {
    "id": "tl-040",
    "name": "Agri-Food & Biosciences Institute",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/agri-food-biosciences-institute",
    "notes": "This facility is involved in food safety monitoring, analysis, and research on the island of Ireland.",
    "source": "Safefood"
  },
  {
    "id": "tl-041",
    "name": "Cork County Council Veterinary Food Safety Laboratory",
    "city": "Cork",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/cork-county-council-veterinary-food-safety-laborat",
    "notes": "This is a food safety laboratory under local government oversight.",
    "source": "Safefood"
  },
  {
    "id": "tl-042",
    "name": "Dairy Science Laboratory, Cork",
    "city": "Cork",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/dairy-science-laboratory-cork",
    "notes": "This laboratory focuses on food safety monitoring and analysis for the dairy sector.",
    "source": "Safefood"
  },
  {
    "id": "tl-043",
    "name": "Dairy Science Laboratory, Limerick",
    "city": "Limerick",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "",
    "notes": "This laboratory provides food safety analysis services for the dairy industry.",
    "source": "Safefood"
  },
  {
    "id": "tl-044",
    "name": "Department of Agriculture, Food and the Marine Laboratories, Backweston",
    "city": "",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/department-of-agriculture-food-and-the-marine-labo",
    "notes": "This is a state-run facility for food safety monitoring and analysis.",
    "source": "Safefood"
  },
  {
    "id": "tl-045",
    "name": "Food Safety Department, Teagasc Food Research Centre",
    "city": "",
    "state": "",
    "type": "university",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/food-safety-department-teagasc-food-research-centr",
    "notes": "This center provides research and testing services to support the food industry.",
    "source": "Safefood"
  },
  {
    "id": "tl-046",
    "name": "Irish Equine Centre",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/irish-equine-centre",
    "notes": "Provides specialized laboratory testing and analysis services.",
    "source": "Safefood"
  },
  {
    "id": "tl-047",
    "name": "Public Health Laboratory, Limerick",
    "city": "Limerick",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-health-laboratory-limerick",
    "notes": "Offers public health-focused food safety testing.",
    "source": "Safefood"
  },
  {
    "id": "tl-048",
    "name": "Northern Ireland Public Health Laboratory",
    "city": "Belfast",
    "state": "NI",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/northern-ireland-public-health-laboratory",
    "notes": "Provides public health and food safety testing services in Northern Ireland.",
    "source": "Safefood"
  },
  {
    "id": "tl-049",
    "name": "Pesticide Control Laboratory, Backweston",
    "city": "",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/pesticide-control-laboratory-backweston",
    "notes": "Specializes in pesticide residue analysis for food safety compliance.",
    "source": "Safefood"
  },
  {
    "id": "tl-050",
    "name": "Public Analyst's Laboratory, Cork",
    "city": "Cork",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-analyst-s-laboratory-cork",
    "notes": "Provides regulatory and safety analysis for food businesses.",
    "source": "Safefood"
  },
  {
    "id": "tl-051",
    "name": "Public Analyst's Laboratory, Dublin",
    "city": "Dublin",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-analyst-s-laboratory-dublin",
    "notes": "State laboratory providing food safety and quality testing services.",
    "source": "Safefood"
  },
  {
    "id": "tl-052",
    "name": "Public Analyst's Laboratory, Galway",
    "city": "Galway",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-analyst-s-laboratory-galway",
    "notes": "Offers analytical testing services to ensure food safety standards.",
    "source": "Safefood"
  },
  {
    "id": "tl-053",
    "name": "Public Health Laboratory, Dublin",
    "city": "Dublin",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-health-laboratory-dublin",
    "notes": "Provides microbiological and chemical food safety testing.",
    "source": "Safefood"
  },
  {
    "id": "tl-054",
    "name": "Public Health Laboratory, Sligo",
    "city": "Sligo",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-health-laboratory-sligo",
    "notes": "Performs public health-related laboratory testing on food samples.",
    "source": "Safefood"
  },
  {
    "id": "tl-055",
    "name": "Public Health Laboratory, Waterford",
    "city": "Waterford",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-health-laboratory-waterford",
    "notes": "Conducts food safety testing for public health monitoring.",
    "source": "Safefood"
  },
  {
    "id": "tl-056",
    "name": "Public Health Microbiology Laboratory, Cork",
    "city": "Cork",
    "state": "",
    "type": "state-program",
    "services": [
      "microbiology"
    ],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-health-microbiology-laboratory-cork",
    "notes": "Provides microbiological analysis of food samples for safety assurance.",
    "source": "Safefood"
  },
  {
    "id": "tl-057",
    "name": "Public Health Microbiology Laboratory, Galway",
    "city": "Galway",
    "state": "",
    "type": "state-program",
    "services": [
      "microbiology"
    ],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/public-health-microbiology-laboratory-galway",
    "notes": "Focuses on microbiological testing to support food safety monitoring.",
    "source": "Safefood"
  },
  {
    "id": "tl-058",
    "name": "The State Laboratory",
    "city": "",
    "state": "",
    "type": "state-program",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/the-state-laboratory",
    "notes": "Provides comprehensive state-level analytical and testing services.",
    "source": "Safefood"
  },
  {
    "id": "tl-059",
    "name": "Alpha Analytical Services",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/alpha-analytical-services",
    "notes": "A private commercial lab providing various food testing and analysis services.",
    "source": "Safefood"
  },
  {
    "id": "tl-060",
    "name": "Aqualab",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/aqualab",
    "notes": "Commercial laboratory offering testing services for the food industry.",
    "source": "Safefood"
  },
  {
    "id": "tl-061",
    "name": "Oldcastle Laboratories",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/oldcastle-laboratories",
    "notes": "Provides commercial food and environmental testing services.",
    "source": "Safefood"
  },
  {
    "id": "tl-062",
    "name": "Fitz Scientific",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/fitz-scientific",
    "notes": "Offers a wide range of analytical testing services for food businesses.",
    "source": "Safefood"
  },
  {
    "id": "tl-063",
    "name": "Beechwood Laboratories",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/beechwood-laboratories",
    "notes": "Private lab providing analysis and testing for the food sector.",
    "source": "Safefood"
  },
  {
    "id": "tl-064",
    "name": "Eurofins Food Testing Ireland (Cork)",
    "city": "Cork",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/eurofins-food-testing-ireland-(cork)",
    "notes": "Global commercial food testing provider with local facilities in Ireland.",
    "source": "Safefood"
  },
  {
    "id": "tl-065",
    "name": "Eurofins Food Testing Ireland (Dungarvan)",
    "city": "Dungarvan",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/eurofins-food-testing-ireland-(dungarvan)",
    "notes": "Commercial food testing services provided by Eurofins.",
    "source": "Safefood"
  },
  {
    "id": "tl-066",
    "name": "Agrihealth Laboratory Services",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/agrihealth-laboratory-services",
    "notes": "Commercial laboratory focusing on health and testing services for food-related entities.",
    "source": "Safefood"
  },
  {
    "id": "tl-067",
    "name": "Complete Laboratory Solutions",
    "city": "Galway",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/complete-laboratory-solutions",
    "notes": "Full-service commercial laboratory offering food testing solutions.",
    "source": "Safefood"
  },
  {
    "id": "tl-068",
    "name": "Bio Search N I",
    "city": "",
    "state": "NI",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/bio-search-n-i",
    "notes": "Commercial testing laboratory based in Northern Ireland.",
    "source": "Safefood"
  },
  {
    "id": "tl-069",
    "name": "Advanced Laboratory Testing (ALT)",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/advanced-laboratory-testing-(alt)",
    "notes": "Private commercial lab offering a variety of testing services for food producers.",
    "source": "Safefood"
  },
  {
    "id": "tl-070",
    "name": "ALS Life Sciences",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/als-life-sciences",
    "notes": "Global commercial provider of food safety analysis and testing.",
    "source": "Safefood"
  },
  {
    "id": "tl-071",
    "name": "Supplement Certified Ltd",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [],
    "website": "https://www.safefood.net/professional/food-safety/food-testing/laboratories/lab-search/supplement-certified-ltd",
    "notes": "Specializes in certification and testing services for food and supplement products.",
    "source": "Safefood"
  },
  {
    "id": "tl-072",
    "name": "North Carolina State University",
    "city": "Raleigh",
    "state": "NC",
    "type": "university",
    "services": [
      "scheduled process"
    ],
    "website": "https://commerce.cashnet.com/NCSUfoodprocessing?ITEMCODE=CALS11-FP",
    "notes": "They provide scheduled process evaluations for food safety compliance.",
    "source": "NCSU Extension"
  },
  {
    "id": "tl-073",
    "name": "NMSU Food Science Laboratory",
    "city": "Las Cruces",
    "state": "NM",
    "type": "university",
    "services": [
      "ph/acidity",
      "water activity",
      "nutrition analysis",
      "shelf life",
      "microbiology",
      "process authority"
    ],
    "website": "https://fsl.nmsu.edu/productquality-nutritionalanalysis.html",
    "notes": "They provide food quality, safety testing, and process authority services to help food founders validate their products and meet regulatory requirements.",
    "source": "NMSU Food Science"
  },
  {
    "id": "tl-074",
    "name": "LSU AgCenter Food Innovation Institute (FOODii)",
    "city": "",
    "state": "LA",
    "type": "university",
    "services": [
      "product development",
      "shelf life",
      "sensory"
    ],
    "website": "https://www.lsuagcenter.com/portals/our_offices/departments/food-science/extension_outreach/incubator",
    "notes": "They assist entrepreneurs with food product development, consumer sensory testing, and shelf-life extension.",
    "source": "LSU AgCenter"
  },
  {
    "id": "tl-075",
    "name": "Medallion Labs",
    "city": "Minneapolis",
    "state": "MN",
    "type": "commercial-lab",
    "services": [
      "nutrition analysis",
      "shelf life",
      "allergen testing",
      "microbiology"
    ],
    "website": "https://www.medallionlabs.com/",
    "notes": "Commercial lab (General Mills-affiliated) popular with small brands for nutrition labels and shelf-life testing.",
    "source": "Medallion Labs"
  },
  {
    "id": "tl-076",
    "name": "RL Food Testing Laboratory",
    "city": "",
    "state": "CA",
    "type": "commercial-lab",
    "services": [
      "nutrition analysis",
      "label review"
    ],
    "website": "https://rlfoodtestinglaboratory.com/",
    "notes": "Budget-friendly nutrition analysis and FDA label formatting aimed at startups.",
    "source": "RL Food Testing"
  },
  {
    "id": "tl-077",
    "name": "Certified Laboratories",
    "city": "",
    "state": "",
    "type": "commercial-lab",
    "services": [
      "nutrition analysis",
      "shelf life",
      "microbiology",
      "allergen testing"
    ],
    "website": "https://certified-laboratories.com/",
    "notes": "National multi-location lab network for nutrition, micro, allergen, and shelf-life testing.",
    "source": "Certified Laboratories"
  },
  {
    "id": "tl-078",
    "name": "Texas A&M Food Processing & Technology (Process Authority)",
    "city": "College Station",
    "state": "TX",
    "type": "university",
    "services": [
      "process authority",
      "ph/acidity",
      "scheduled process"
    ],
    "website": "https://aggie-horticulture.tamu.edu/food-technology/",
    "notes": "Accepts acidified food samples for process review; publishes founder getting-started guides.",
    "source": "Texas A&M AgriLife"
  },
  {
    "id": "tl-079",
    "name": "University of Nebraska Food Processing Center",
    "city": "Lincoln",
    "state": "NE",
    "type": "university",
    "services": [
      "product development",
      "process authority",
      "shelf life",
      "nutrition analysis"
    ],
    "website": "https://fpc.unl.edu/",
    "notes": "Full-service center for food entrepreneurs: product development, process review, and testing.",
    "source": "UNL Food Processing Center"
  },
  {
    "id": "tl-080",
    "name": "Washington State University Pilot Plant",
    "city": "Pullman",
    "state": "WA",
    "type": "university",
    "services": [
      "product development",
      "scheduled process"
    ],
    "website": "https://sfs.wsu.edu/outreach-extension/pilot-plant/",
    "notes": "Pilot plant for trial runs and process development in the Pacific Northwest.",
    "source": "WSU Food Science"
  },
  {
    "id": "tl-081",
    "name": "Purdue University Food Science Pilot Plant",
    "city": "West Lafayette",
    "state": "IN",
    "type": "university",
    "services": [
      "product development",
      "scheduled process"
    ],
    "website": "https://ag.purdue.edu/department/foodsci/pilot-plant.html",
    "notes": "Pilot plant supporting product and process development for Midwest founders.",
    "source": "Purdue Food Science"
  }
];
